import React from "react";
import { CssPrice, Button, ContentBlock, HH, T } from '../uikit-b2c/uikit-b2c';
import { Ffr } from "./Ffr";
export const TotalPay = ({ ffr = 'loyal', blocked = true, handle = () => void (0) }) => {
  return (<ContentBlock appearance="flatten">




    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

      <Ffr ffr={ffr} />

      <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        <HH paddings={false} tag='h1'><CssPrice>$34.99</CssPrice></HH>&nbsp;&nbsp;&nbsp;
        <Button blocked={blocked}
          // size="lg"
          onClick={() => handle("status")}>Pay now</Button>
      </div>

    </div>



  </ContentBlock>);
};
